module.exports = __webpack_public_path__ + "img/tips.3a672358.svg";